module.exports = __webpack_public_path__ + "static/media/mountain_range_himalayas_mountains_sky_fog_103464_1920x1080.3240acb2.jpg";